import { merge } from 'lodash';
import { SET_DATA, SET_ERROR } from 'helpers/Constants';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_DATA:
      return merge({}, state, action.payload);
    case SET_ERROR:
      return merge({}, state, { errors: action.payload });
    default:
      return state;
  }
};
